import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutes } from 'src/app/core/models/routes.model';
import { AppContextService } from 'src/app/core/services/app-context.service';
import { WidgetBoxItem } from 'src/app/shared/models/widget.model';

@Component({
    selector: 'ui-widget-box',
    templateUrl: './widget-box.component.html',
    styleUrls: ['./widget-box.component.scss'],
    standalone: false
})
export class WidgetBoxComponent {
  @Input() item!: WidgetBoxItem;
  @Input() widgetStyle: 'internal' | 'external' = 'internal';
  router = inject(Router);
  appContextService = inject(AppContextService);

  get sizeClass(): string {
    return this.item?.size || 'col-12 md:col-6 lg:col-4';
  }

  get progressColor(): string {
    const progress = ((this.item.value || 0) / (this.item.maxValue || 0)) * 100 || 0;
    if (progress < 75) {
      return 'var(--primary-color)';
    } else {
      return 'var(--error-color)';
    }
  }

  getBackgroundType(): string {
    return this.item.backgroundType || 'color';
  }
  getBackground(): string {
    if (this.item.background) {
      return this.item.background;
    } else {
      return this.widgetStyle === 'external' ? 'var(--surface-section)' : 'var(--surface-ground)';
    }
  }
  getTextColor(): string {
    return this.item.textColor || 'var(--text-color)';
  }

  getButtonClass(defaultClass = ''): string {
    return [defaultClass, this.item.buttonClass || this.item.iconButtonClass || '']
      .join(' ')
      .trim();
  }

  getWidgetStyles(): Record<string, string> {
    const styles: Record<string, string> = {
      color: this.getTextColor(),
    };

    if (this.getBackgroundType() === 'image') {
      styles['background-image'] = `url('${this.getBackground()}')`;
      styles['background-size'] = 'cover';
      styles['background-position'] = 'center';
      styles['background-repeat'] = 'no-repeat';
    } else {
      styles['background'] = this.getBackground();
      styles['box-shadow'] =
        this.widgetStyle === 'external' ? '0 0 5px 0 rgba(0, 0, 0, 0.1)' : 'none';
    }

    return styles;
  }

  getDescriptionColor(): string {
    const progress = ((this.item.value || 0) / (this.item.maxValue || 0)) * 100 || 0;
    if (progress < 75) {
      return 'var(--muted-color)';
    } else {
      return 'var(--error-color)';
    }
  }

  onButtonClick(): void {
    if (this.item.routerLink) {
      this.router.navigateByUrl(this.resolveRouterLink(this.item.routerLink));
    }
  }

  private resolveRouterLink(routerLink: string): string {
    const normalizedLink = routerLink.startsWith('/') ? routerLink : `/${routerLink}`;
    const appScopedRoutes = [AppRoutes.DASHBOARD, AppRoutes.AZIENDE, AppRoutes.PROCURATORI, AppRoutes.ACQUISTI];

    for (const route of appScopedRoutes) {
      if (normalizedLink === `/${AppRoutes.MAIN_ROUTE}/${route}`) {
        return this.appContextService.buildAppScopedUrl(route);
      }
    }

    return normalizedLink;
  }
}
